// The backend selects the reward from the authenticated account's tenant.
export const phoneVerificationReward = (user) => {
  const amount = Number(user?.phone_verification_reward_amount);
  return Number.isFinite(amount) && amount > 0 ? amount : 5;
};
